import {EmailImage} from '../email/emailImage';
import {ThirdPartyShare} from '../social-sharing/thirdPartyShare';
import {TextMessage} from '../email/TextMessage';
import {ConditionsEvaluator} from '../email/ConditionsEvaluator';
import {PhoneNumber} from './phoneNumber';
import { TSMap } from 'typescript-map';
import {JsonObject, JsonProperty} from 'json2typescript';
import {TSStringToStringMapConverter} from '../../customJsonConverters/TSStringToStringMapConverter';
import {EmailImageArrayConverter} from '../../customJsonConverters/EmailImageArrayConverter';
import {ThirdPartyShareConverter} from '../../customJsonConverters/ThirdPartyShareConverter';
import {TextMessageConverter} from '../../customJsonConverters/TextMessageConverter';
import {ConditionConverter} from '../../customJsonConverters/ConditionConverter';
import {MultipleCondition} from '../Conditions/MultipleCondition';
import {Condition} from '../Conditions/Condition';

@JsonObject('Sms')
export class Sms {
    @JsonProperty('uid')
    uid = '';

    @JsonProperty('messageArray',TextMessageConverter)
    messageArray:Array<TextMessage> = [];

    @JsonProperty('titleMap',TSStringToStringMapConverter)
    titleMap:TSMap<string,string> = new TSMap();

    @JsonProperty('phoneNumber')
    phoneNumber =  new PhoneNumber();

    @JsonProperty('linksMap',ThirdPartyShareConverter)
    linksMap: TSMap<string,ThirdPartyShare> = new TSMap(); // { [key:string]:ThirdPartyShare; } = {};

    @JsonProperty('mediaContent',EmailImageArrayConverter)
    mediaContent: Array<EmailImage> = [];

    @JsonProperty('condition',ConditionConverter)
    condition:Condition = new MultipleCondition();

    constructor() {
    }


}
